const WriteIcon = ({ size = 56, isActive = false, className = "", ...props }) => {
  const fillColor = isActive ? "#68D7FF" : "#9EA6B2";
  const fillOpacity = isActive ? "0.3" : "0.3";
  const strokeColor = isActive ? "url(#paint0_linear_active)" : "url(#paint0_linear)";
  const iconColor = "white";

  return (
    <svg 
      width={size} 
      height={size} 
      viewBox="0 0 56 56" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg" 
      className={className}
      {...props}
    >
      <defs>
        <linearGradient id="paint0_linear" x1="3.95297" y1="4.40429" x2="50.7637" y2="54.4557" gradientUnits="userSpaceOnUse">
          <stop stopColor="white"/>
          <stop offset="1" stopColor="white" stopOpacity="0"/>
        </linearGradient>
        <linearGradient id="paint0_linear_active" x1="3.95297" y1="4.40429" x2="50.7637" y2="54.4557" gradientUnits="userSpaceOnUse">
          <stop stopColor="#68D7FF"/>
          <stop offset="1" stopColor="#68D7FF" stopOpacity="0"/>
        </linearGradient>
      </defs>
      
      {/* Background circle - removed blur effect for better performance */}
      
      <g data-figma-bg-blur-radius="9.05275">
        {/* Background circle */}
        <path 
          d="M28 1C42.9117 1 55 13.0883 55 28C55 42.9117 42.9117 55 28 55C13.0883 55 1 42.9117 1 28C1 13.0883 13.0883 1 28 1Z" 
          fill={fillColor} 
          fillOpacity={fillOpacity}
        />
        
        {/* Border stroke */}
        <path 
          d="M28 1C42.9117 1 55 13.0883 55 28C55 42.9117 42.9117 55 28 55C13.0883 55 1 42.9117 1 28C1 13.0883 13.0883 1 28 1Z" 
          stroke={strokeColor} 
          strokeWidth="2"
        />
        
        {/* Pencil icon */}
        <path 
          d="M33.9955 16.7543C33.4105 16.7628 32.8506 16.9967 32.4374 17.4086L30.712 19.1325L35.4025 23.823L37.1279 22.0991C38.0006 21.2254 38.0006 19.7846 37.1279 18.911C37.1279 18.911 35.6216 17.4086 35.6196 17.4086C35.1878 16.9782 34.6052 16.7436 33.9955 16.7543ZM29.6498 20.1947L18.9117 30.9328C18.4917 31.3545 18.252 31.9294 18.2515 32.5247V35.5294C18.2499 35.9471 18.5894 36.2859 19.0071 36.2835L22.0118 36.2776C22.6071 36.2771 23.1761 36.0434 23.5978 35.6233L34.3418 24.8852L29.6498 20.1947ZM18.9308 37.7859C18.9303 37.7863 18.9298 37.7868 18.9293 37.7874C17.9509 37.8598 18.0264 39.3187 19.0071 39.2897H37.034C38.0583 39.3127 38.0583 37.7644 37.034 37.7874H19.0071C18.9817 37.7856 18.9562 37.7851 18.9308 37.7859Z" 
          fill={iconColor}
        />
      </g>
      

    </svg>
  );
};

export default WriteIcon; 